var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialX = function SvgSocialX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--on-surface)",
    d: "M14.076 10.618 20.63 3h-1.553l-5.69 6.614L8.841 3H3.6l6.872 10.002L3.6 20.991h1.553l6.009-6.985 4.8 6.985h5.241l-7.127-10.373ZM5.712 4.169h2.386l10.98 15.706h-2.386L5.712 4.169Z"
  })));
};
export default SvgSocialX;